import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { DatePicker } from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUser,
  FaVenusMars,
  FaUsers,
  FaBirthdayCake,
  FaEnvelope,
  FaPhone,
  FaAddressCard,
  FaBuilding,
  FaUniversity,
  FaMoneyCheckAlt,
  FaIdCard,
} from "react-icons/fa";

import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

// Utility to convert date to MM-DD-YYYY if needed
function convertToMMDDYYYY(dateStr) {
  if (!dateStr) return "";
  const d = dayjs(dateStr, ["YYYY-MM-DD", "MM-DD-YYYY"]);
  return d.isValid() ? d.format("MM-DD-YYYY") : "";
}

const EmployeeUpdateChild = ({ emp_details }) => {
  console.log(emp_details);
  let navigate = useNavigate();
  const inputWidth = "230px";
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid lightgray",
      // This line disable the blue border
      boxShadow: "none",
    }),
  };
  //Error Logging Service & Santize Input
  const [{ errorLogApi, placeHolderText, user }] = useAtom(gbState);
  const [selectedImage, setSelectedImage] = useState(null);
  const [formData, setFormData] = useState({
    ...emp_details,
    date_of_birth: convertToMMDDYYYY(emp_details.date_of_birth),
    date_of_joining: convertToMMDDYYYY(emp_details.date_of_joining),
    date_of_leaving: convertToMMDDYYYY(emp_details.date_of_leaving),
  });

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const inputElementWidthStyle = `w-full p-3 h-10 font-sans text-sm font-light border border-gray-300 rounded-md outline-none`;

  const dropDownChange = (selected, dropdown) => {
    setFormData({
      ...formData,
      [dropdown.name]: selected.value,
    });
  };

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "nonbinary", label: "Non-binary" },
    { value: "other", label: "Other" },
  ];

  const employeeStatusOptions = [
    { value: true, label: "Active" },
    { value: false, label: "Disabled" },
  ];

  const designationOptions = [
    { value: "administrator", label: "Administrator" },
    { value: "counselor", label: "Counselor" },
    { value: "youthassociate", label: "Youth Associate" },
    { value: "childrenassociate", label: "children's Associate" },
    { value: "nurserystaffcooridinator", label: "Nursery Staff Cooridinator" },
    { value: "musicministor", label: "Music Ministor" },
    { value: "organist", label: "Organist" },
    { value: "pianist", label: "Pianist" },
    { value: "security", label: "Security" },
    { value: "seniorpastor", label: "Senior Pastor" },
    { value: "womenministorypastor", label: "Women's Ministory Pastor" },
    { value: "3choirdirector", label: "3,Choir Director" },
  ];
  const handleEmployeeRegistration = (e) => {
    e.preventDefault();
    // if (formData.password !== formData.confirm_password) {
    //   toast.error("Passwords do not match");
    //   return;
    // }

    //formData['image']=image;
    // console.log(formData);

    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/employee/update/${emp_details._id}`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData, image: selectedImage },
    };
    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        toast.success("Employee Updated Successfully.");
        navigate("/employees");
      })
      .catch(function (error) {
        //  toast.error(JSON.stringify(error.response.data.message));
        toast.error(JSON.stringify(error?.response?.data));
        errorLogApi(error, "EmployeeUpdateChild", "/employee/update");
        // console.log(error);
      });
  };

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };
  //console.log(image);
  return (
    <div className="max-w-4xl p-6 mx-auto bg-white rounded-lg shadow-lg">
      <h2 className="mb-6 text-2xl font-semibold text-gray-800">
        Update Employee / Volunteer
      </h2>
      <form onSubmit={(e) => handleEmployeeRegistration(e)} autoComplete="off">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="space-y-4">
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Upload Image
              </label>
              <input
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                name="image"
                type="file"
                onChange={handleImageChange}
                accept="image/gif, image/jpeg, image/png"
              />
            </div>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                First Name
              </label>
              <div className="relative">
                <input
                  className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  name="first_name"
                  type="text"
                  required
                  placeholder="Enter First Name"
                  autoComplete="new-password"
                  onChange={handleChange}
                  value={formData.first_name}
                />
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <FaUser className="w-5 h-5 text-gray-400" />
                </div>
              </div>
            </div>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Last Name
              </label>
              <div className="relative">
                <input
                  className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  name="last_name"
                  type="text"
                  placeholder="Enter Last Name"
                  autoComplete="new-password"
                  onChange={handleChange}
                  value={formData.last_name}
                />
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <FaUser className="w-5 h-5 text-gray-400" />
                </div>
              </div>
            </div>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Designation
              </label>
              <Select
                name="designation"
                onChange={dropDownChange}
                options={designationOptions}
                placeholder={placeHolderText("Select Designation")}
                className={`mt-3 h-11 outline-none w-[${inputWidth}]`}
                menuPortalTarget={document.body}
                menuPosition={"fixed"}
                value={designationOptions?.find(
                  (designation) => designation.value === formData?.designation
                )}
              />
            </div>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Mobile No
              </label>
              <div className="relative">
                <input
                  className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  name="mobile"
                  type="text"
                  required
                  placeholder="Enter Mobile"
                  autoComplete="new-password"
                  onChange={handleChange}
                  value={formData.mobile}
                />
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <FaPhone className="w-5 h-5 text-gray-400" />
                </div>
              </div>
            </div>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Email
              </label>
              <div className="relative">
                <input
                  className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  name="email"
                  type="email"
                  required
                  placeholder="Enter Email"
                  autoComplete="new-password"
                  onChange={handleChange}
                  value={formData.email}
                />
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <FaEnvelope className="w-5 h-5 text-gray-400" />
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-4">
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Gender
              </label>
              <Select
                name="gender"
                onChange={dropDownChange}
                options={genderOptions}
                className={`h-10 outline-none w-[${inputWidth}]`}
                placeholder={placeHolderText("Select Gender")}
                menuPortalTarget={document.body}
                menuPosition={"fixed"}
                styles={style}
                value={genderOptions?.find(
                  (gender) => gender.value === formData?.gender
                )}
              />
            </div>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Date of Birth
              </label>
              <DatePicker
                className="w-full mb-2 h-[38px]"
                name="date_of_birth"
                format="MM-DD-YYYY"
                onChange={(date, dateString) => {
                  setFormData({
                    ...formData,
                    date_of_birth: dateString,
                  });
                }}
                disabledDate={(current) => {
                  let customDate = dayjs().format("YYYY-MM-DD");
                  return current && current > dayjs(customDate, "YYYY-MM-DD");
                }}
                showToday={true}
                value={
                  formData?.date_of_birth &&
                  dayjs(formData?.date_of_birth, "MM-DD-YYYY")
                }
              />
            </div>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Date of Joining
              </label>
              <DatePicker
                className="w-full mb-2 h-[38px]"
                name="date_of_joining"
                format="MM-DD-YYYY"
                onChange={(date, dateString) => {
                  setFormData({
                    ...formData,
                    date_of_joining: dateString,
                  });
                }}
                showToday={true}
                value={
                  formData?.date_of_joining &&
                  dayjs(formData?.date_of_joining, "MM-DD-YYYY")
                }
              />
            </div>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Date of leaving
              </label>
              <DatePicker
                className="w-full mb-2 h-[38px]"
                name="date_of_leaving"
                format="MM-DD-YYYY"
                onChange={(date, dateString) => {
                  setFormData({
                    ...formData,
                    date_of_leaving: dateString,
                  });
                }}
                showToday={true}
                value={
                  formData?.date_of_leaving &&
                  dayjs(formData?.date_of_leaving, "MM-DD-YYYY")
                }
              />
            </div>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Employee Status
              </label>
              <Select
                name="employee_status"
                onChange={dropDownChange}
                options={employeeStatusOptions}
                className={`h-10 outline-none w-[${inputWidth}]`}
                placeholder={placeHolderText("Select Gender")}
                menuPortalTarget={document.body}
                menuPosition={"fixed"}
                styles={style}
                value={employeeStatusOptions?.find(
                  (s) => s.value === formData?.employee_status
                )}
              />
            </div>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Address
              </label>
              <div className="relative">
                <input
                  className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  name="address"
                  type="text"
                  required
                  placeholder="Enter Address"
                  onChange={handleChange}
                  value={formData.address}
                />
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <FaAddressCard className="w-5 h-5 text-gray-400" />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">
                  Bank Name
                </label>
                <div className="relative">
                  <input
                    className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    name="bank_name"
                    type="text"
                    autoComplete="off"
                    onChange={handleChange}
                    value={formData.bank_name}
                  />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FaBuilding className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              </div>
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">
                  Branch Name
                </label>
                <div className="relative">
                  <input
                    className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    name="branch_name"
                    type="text"
                    autoComplete="off"
                    onChange={handleChange}
                    value={formData.branch_name}
                  />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FaUniversity className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">
                  Routing Number
                </label>
                <div className="relative">
                  <input
                    className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    name="ifsc_code"
                    type="text"
                    autoComplete="off"
                    onChange={handleChange}
                    value={formData.ifsc_code}
                  />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FaIdCard className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              </div>
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">
                  Account
                </label>
                <div className="relative">
                  <input
                    className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    name="account_number"
                    type="text"
                    autoComplete="off"
                    onChange={handleChange}
                    value={formData.account_number}
                  />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <FaMoneyCheckAlt className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end mt-8 space-x-4">
          <button
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            onClick={() => navigate(-1)}
            type="button"
          >
            Back
          </button>
          <button
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            type="submit"
          >
            Update
          </button>
        </div>
      </form>
    </div>
  );
};

export default EmployeeUpdateChild;
